import { Membership } from 'types/membership';

/**
 * Enforces the list-memberships contract: last name, then first name (case-insensitive).
 */
export function sortMembershipsByLastThenFirstName(
  rows: Membership[],
): Membership[] {
  return [...rows].sort((a, b) => {
    const lastCmp = (a.lastName ?? '')
      .trim()
      .localeCompare((b.lastName ?? '').trim(), undefined, {
        sensitivity: 'base',
      });
    if (lastCmp !== 0) return lastCmp;
    return (a.firstName ?? '')
      .trim()
      .localeCompare((b.firstName ?? '').trim(), undefined, {
        sensitivity: 'base',
      });
  });
}
